/**
 * @author Dmitriy Lebedev
 */
import { makeAutoObservable } from 'mobx';
import { isDemoUseMock, isDevEnv } from '../config';

export const ROOT_SCOPE = 'root';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IStores {}

export class RootStore {
  private static _instance?: RootStore;

  private static _setupFns = new Map<keyof IStores, (scope?: string) => any>();

  static setSetupFn<TKey extends keyof IStores>(key: TKey, setupFn: (scope?: string) => IStores[TKey]) {
    this._setupFns.set(key, setupFn);
  }

  static get instance() {
    if (!this._instance) {
      this._instance = new RootStore();

      if (isDevEnv || isDemoUseMock) {
        // @ts-ignore
        window.__ROOT_STORE = this._instance;
      }
    }
    return this._instance;
  }

  /**
   * @deprecated
   */
  static forbidScope(scope?: string) {}

  private _store = new Map<keyof IStores, any>();

  private constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  clear() {
    this._store.forEach((item, name) => {
      try {
        item.purge?.();
        item.dispose?.();
      } catch (err) {
        console.error(`Error while purge ${name}`, err);
      }
    });

    this._store = new Map();
  }

  clearAll() {
    this.clear();
  }

  /**
   * @deprecated
   */
  clearScope(scope: string) {}

  get<TKey extends keyof IStores>(key: TKey, scope = ROOT_SCOPE, forceSetup = false): IStores[TKey] {
    if (!this._store?.has(key) || forceSetup) {
      if (!RootStore._setupFns.has(key)) {
        throw new Error(`Setup function for ${key} must be set`);
      }

      this._store.set(key, RootStore._setupFns.get(key)?.());
    }

    return this._store.get(key);
  }
}
